import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import { initLenis } from "./utils/lenis";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  useEffect(() => {
    // Initialize smooth scrolling with Lenis
    const lenis = initLenis();
    
    return () => {
      if (lenis) {
        lenis.destroy();
      }
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
